import React from 'react';

const CasesSection: React.FC = () => {
  // Sample project data
  const projects = [
    {
      id: 1,
      title: "Personal Portfolio Website",
      description: "A responsive portfolio website built with React and TypeScript, featuring smooth animations and interactive elements.",
      technologies: ["React", "TypeScript", "CSS"],
      imageUrl: "/assets/project1.jpg",
      demoUrl: "#",
      codeUrl: "https://github.com/yourusername/portfolio"
    },
    {
      id: 2,
      title: "Mental Health Spa Website",
      description: "A full-stack application for managing tasks and projects with user authentication and real-time updates.",
      technologies: ["React", "Node.js", "MongoDB", "Socket.io"],
      imageUrl: "/assets/project2.jpg",
      demoUrl: "#",
      codeUrl: "https://github.com/yourusername/task-manager"
    },
    {
      id: 3,
      title: "Knights Mental Health Website",
      description: "An online resource that is available to everyone. A project a worked in conjunction with a team.",
      technologies: ["React", "Weblium"],
      imageUrl: "/assets/project3.jpg",
      demoUrl: "#",
      codeUrl: "https://github.com/yourusername/ecommerce"
    },
    {
      id: 4,
      title: "Website Development and IT Consulting Service",
      description: "A website and IT service business webpage to help others streamline their work. ",
      technologies: ["JavaScript", "HTML", "CSS",],
      imageUrl: "/assets/project4.jpg",
      demoUrl: "#",
      codeUrl: "https://github.com/yourusername/weather-app"
    }
  ];

  return (
    <section className="projects-section">
      <div className="projects-container">
        <h2 className="section-title">MY PROJECTS</h2>
        
        <div className="projects-grid">
          {projects.map(project => (
            <div key={project.id} className="project-card">
              <div className="project-image">
                <img 
                  src={project.imageUrl} 
                  alt={project.title}
                  onError={(e) => {
                    e.currentTarget.src = `https://via.placeholder.com/600x400/2d2d2d/ffffff?text=${project.title}`;
                  }}
                />
              </div>
              
              <div className="project-content">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>
                
                <div className="project-technologies">
                  {project.technologies.map((tech, index) => (
                    <span key={index} className="tech-tag">{tech}</span>
                  ))}
                </div>
                
                <div className="project-links">
                  <a href={project.demoUrl} className="project-link" target="_blank" rel="noopener noreferrer">
                    Live Demo
                  </a>
                  <a href={project.codeUrl} className="project-link" target="_blank" rel="noopener noreferrer">
                    Source Code
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CasesSection; 